import { Loader2, Star, MessageSquare } from "lucide-react";
import { useVendorReviews } from "@/hooks/useVendor";
import { formatDate, fileUrlSafe } from "./vendorUtils";

function Stars({ n }) {
  return (
    <span className="flex gap-0.5">
      {[1, 2, 3, 4, 5].map((i) => (
        <Star key={i} className={`h-3.5 w-3.5 ${i <= n ? "fill-amber-400 text-amber-400" : "text-slate-300"}`} />
      ))}
    </span>
  );
}

export default function VendorReviews() {
  const { data, isLoading } = useVendorReviews();
  const items = data?.items || [];

  return (
    <div className="space-y-5" data-testid="vendor-reviews">
      <div>
        <h1 className="font-display text-2xl font-extrabold text-ink">Avis clients</h1>
        <p className="mt-1 text-sm text-slate-500">Avis laissés sur vos produits et formations uniquement.</p>
      </div>

      <div className="grid grid-cols-2 gap-3 sm:max-w-md">
        <div className="rounded-2xl border border-line bg-white p-4" data-testid="reviews-count">
          <p className="text-[11px] font-bold uppercase tracking-wide text-slate-400">Avis reçus</p>
          <p className="mt-1 font-display text-xl font-extrabold text-ink">{data?.count || 0}</p>
        </div>
        <div className="rounded-2xl border border-line bg-white p-4" data-testid="reviews-average">
          <p className="text-[11px] font-bold uppercase tracking-wide text-slate-400">Note moyenne</p>
          <p className="mt-1 flex items-center gap-1.5 font-display text-xl font-extrabold text-ink">
            {data?.average || 0} <Star className="h-4 w-4 fill-amber-400 text-amber-400" />
          </p>
        </div>
      </div>

      {isLoading ? (
        <div className="flex h-40 items-center justify-center"><Loader2 className="h-6 w-6 animate-spin text-brand" /></div>
      ) : !items.length ? (
        <div className="rounded-2xl border border-dashed border-line bg-white p-10 text-center">
          <MessageSquare className="mx-auto h-9 w-9 text-slate-300" />
          <p className="mt-3 text-sm text-slate-500">Aucun avis pour le moment.</p>
        </div>
      ) : (
        <div className="space-y-3">
          {items.map((r) => (
            <div key={r.id} data-testid={`vreview-${r.id}`} className="flex gap-3 rounded-2xl border border-line bg-white p-4">
              <span className="flex h-11 w-11 shrink-0 items-center justify-center overflow-hidden rounded-lg bg-slate-100">
                {r.item_image ? <img src={fileUrlSafe(r.item_image)} alt="" className="h-full w-full object-cover" /> : <Star className="h-4 w-4 text-slate-300" />}
              </span>
              <div className="min-w-0 flex-1">
                <div className="flex flex-wrap items-center gap-2">
                  <p className="text-sm font-bold text-ink">{r.item_name}</p>
                  <span className={`rounded-full px-2 py-0.5 text-[10px] font-bold ${r.item_kind === "formation" ? "bg-violet-50 text-violet-600" : "bg-brand-light text-brand"}`}>
                    {r.item_kind === "formation" ? "Formation" : "Produit"}
                  </span>
                  <Stars n={r.rating} />
                </div>
                <p className="mt-1 text-sm text-slate-600">{r.comment}</p>
                {r.reply && <p className="mt-1.5 rounded-lg bg-surface px-3 py-2 text-xs text-slate-500"><span className="font-bold">Réponse :</span> {r.reply}</p>}
                <p className="mt-1 text-[11px] text-slate-400">{r.author_name || "Client"} · {formatDate(r.created_at)}</p>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
